import MainLayout from '../../layouts/MainLayout/MainLayout';
import Spinner from '../Spinner/Spinner';

const PageFallback = () => {
  return (
    <MainLayout>
      <div>
        <div className="flex h-[65%] w-full items-center gap-[20px] text-sm"></div>
      </div>
      <Spinner />
    </MainLayout>
  );
};

export default PageFallback;
